import { useContext, useMemo } from 'react';
import { WidenPrimitives } from '@growthbook/growthbook';

import { ShellConfigContextValue } from '../shell/contexts';

export const useFeatureManagerContext = () => useContext(ShellConfigContextValue)?.featureManager;

/** Получение значения фичи.
 * При попадании в эксперимент отправляется событие просмотра эксперимента в аналитику (с учетом deps).
 * @param deps - Дополнительный список зависимостей, при изменении которых необходимо пересчитать фичу и отправить событие аналитики заново.
 * В большинстве случаев ничего указывать не нужно.
 * @see {@link featureManager.getFeatureValue} как альтернатива (например если получение фичи уже находитья в хуке или происходит по какому-то действию),
 * но тогда управлять повторными вызовами нужно самим.
 */
export function useFeatureValue<T>(
    featureName: string,
    defaultValue: T,
    deps: React.DependencyList = [],
): WidenPrimitives<T> {
    const featureManager = useFeatureManagerContext();

    if (!featureManager) {
        console.error('FeatureManager either used in wrong context or not initialized yet');
    }

    // experimentHash - если изменились таргетинги и пользователь попал в другой эксперимент/вариацию,
    // то нужно пересчитать заново фичу и отправить новое событие аналитики.
    const experimentHash = featureManager?.getExperimentHash(featureName);

    return useMemo(() => {
        return featureManager?.getFeatureValue(featureName, defaultValue) ?? (defaultValue as WidenPrimitives<T>);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [experimentHash, featureName, defaultValue, featureManager, ...deps]);
}
